export default "__VITE_ASSET__C0_y_od7__"